<!-- main template for [virtual] table-->
<ng-container *ngIf="virtual else notVirtualTemplate">

    <div class="column-filters-warning gup-U-color--orange" *ngIf="isFiltered">

        <p class="small">
            Les filtres de colonne ne s'appliquent que sur les résultats affichés, ils ne tiennent pas compte de la pagination et ne seront pas appliqués lors d'un export.
        </p>

    </div>

    <cdk-virtual-scroll-viewport
        [itemSize]="virtualItemSize"
        [style.height]="virtualViewPortHeight"
        [style.width.%]="100"
        kalFixedTable>
        <table class="gup-C-table__basic -virtual">
            <thead>
            <ng-container kalHeaderRowOutlet></ng-container>
            </thead>

            <tbody>
            <tr (click)="rowClicked(row)"
                *cdkVirtualFor="let row of dataSource; let index=index"
                [ngClass]="virtualRowClassFunction(row)"
                [class.selected]="isSelected(row)">
                <ng-container *ngFor="let code of displayedColumns">
                    <ng-container
                        *kalTemplateOutlet="getCellTemplate(code); context: getRowContext({$implicit: row, code: code, index: index}); callback: addClassOnCreatedCell(code)"
                    ></ng-container>
                </ng-container>
            </tr>
            <!-- template for empty table -->
            <ng-container *ngTemplateOutlet="emptyTableTemplate"></ng-container>
            </tbody>

            <tfoot>
            <ng-container kalFooterRowOutlet></ng-container>
            </tfoot>
        </table>
    </cdk-virtual-scroll-viewport>
</ng-container>

<!-- main template for :not([virtual]) table -->
<ng-template #notVirtualTemplate>
    <table class="gup-C-table__basic">
        <thead>
            <ng-container kalHeaderRowOutlet></ng-container>
        </thead>
        <tbody>
            <ng-container kalBodyRowOutlet></ng-container>
            <!-- template for empty table -->
            <ng-container *ngTemplateOutlet="emptyTableTemplate"></ng-container>
        </tbody>
        <tfoot>
            <ng-container kalFooterRowOutlet></ng-container>
        </tfoot>
    </table>
</ng-template>

<!-- extra row added when table is empty -->
<ng-template #emptyTableTemplate>
    <tr *ngIf="!hasRows" [class]="emptyRowClassName">
        <td [attr.colspan]="displayedColumns.length">
            {{ placeholder  }}
        </td>
    </tr>
</ng-template>

<!-- default rows -->
<tr (click)="rowClicked(row)"
    *kalBodyRowDef="let row"
    [class.selected]="isSelected(row)"
    kal-body-row></tr>

<!-- kal-defaut column -->
<ng-container [kalColumn]="defaultColumnName">
    <!--
        TODO
         Trouver une manière de simplifier le passage du code en automatique
         de kalHeaderCell vers kalTableHeader, là je sèche .... passer par un ngTemplate ?
    -->
    <th *kalHeaderCell="let code = code" [kalTableHeader]="code">
        {{ getColumn(code)?.label  }}
    </th>

    <td (click)="cellClicked({resource: row, column: code})"
        *kalBodyCell="let row let code = code">
        {{ row[code] }}
    </td>

    <td *kalFooterCell></td>
</ng-container>

<!-- kal-select column -->
<ng-container [kalColumn]="selectColumnName">
    <th *kalHeaderCell>
        <kal-checkbox #filsdetableau
            *ngIf="!disableSelectAllCheckbox"
            [kalTheme]="theme || null"
            (click)="selectAll($event)"
            [value]="isAllSelected()"
        ></kal-checkbox>
    </th>
    <td
        *kalBodyCell="let row">
        <kal-checkbox
            [kalTheme]="theme || null"
            (click)="select(row, $event)"
            [value]="isSelected(row)"
        ></kal-checkbox>
    </td>
    <td *kalFooterCell></td>
</ng-container>

<!-- kal-action column -->
<ng-container [kalColumn]="actionColumnName">
    <th *kalHeaderCell></th>
    <td (click)="cellClicked({resource: row, column: actionColumnName})"
        *kalBodyCell="let row"
        style="text-align: right">
        <kal-icon>chevron_right</kal-icon>
    </td>
    <td *kalFooterCell></td>
</ng-container>
